import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/pro-light-svg-icons";
import Checkbox from "react-custom-checkbox";
import { usePageTitle } from "../../../hooks/useMeta";
import Tabs from "../../tabs/Tabs";
import { getRequest } from "../../../api/methodsCfg";
import BookingCalendarView from "./bookings/BookingCalendarView";
import BookingTablesView from "./bookings/BookingTablesView";

const RestaurantBookings = ({ tKey = "dashboard.bookings." }) => {
  usePageTitle("restaurantBookings");
  const { t } = useTranslation();
  const restaurantId = useSelector((state) => state.user.restaurantId);
  const controlledRestaurantId = useSelector(
    (state) => state.admin.controlledRestaurantId,
  );

  const activeRestaurantId = controlledRestaurantId || restaurantId;

  const [defaultDuration, setDefaultDuration] = useState(2);
  const [hideCanceled, setHideCanceled] = useState(false);

  // Fetch default booking duration for the calendar view
  useEffect(() => {
    if (!activeRestaurantId) return;
    const fetchDefaultDuration = async () => {
      try {
        const response = await getRequest(`/restaurant/${activeRestaurantId}`);
        if (response.data?.defaultBookingDuration != null) {
          setDefaultDuration(Number(response.data.defaultBookingDuration));
        }
      } catch (err) {
        console.warn("Could not fetch restaurant settings:", err);
      }
    };
    fetchDefaultDuration();
  }, [activeRestaurantId]);

  if (!activeRestaurantId) {
    return null;
  }

  return (
    <div className="dashboard-content bookings-management">
      <div className="bg-white rounded p-3">
        {/* Booking views tabs */}
        <Tabs
          tabs={[
            {
              name: "calendar",
              content: () => (
                <BookingCalendarView
                  defaultDuration={defaultDuration}
                  hideCanceled={hideCanceled}
                />
              ),
            },
            {
              name: "tables",
              content: () => (
                <BookingTablesView hideCanceled={hideCanceled} />
              ),
            },
          ]}
          tKey={`${tKey}tabs.`}
          contentClass="bookings-tab-content"
        >
          <Checkbox
            className="border-dark"
            icon={
              <div>
                <FontAwesomeIcon
                  icon={faCheck}
                  size="sm"
                  className="text-dark"
                />
              </div>
            }
            label={t(`${tKey}calendar.hideCanceled`)}
            checked={hideCanceled}
            onChange={(checked) => setHideCanceled(checked)}
          />
          <div className="bookings-legend ml-auto">
            <span className="bookings-legend__item">
              <span className="bookings-legend__dot bookings-legend__dot--danger" />
              <span className="bookings-legend__label">{t(`${tKey}legend.booking`)}</span>
            </span>
            <span className="bookings-legend__item">
              <span className="bookings-legend__dot bookings-legend__dot--warning" />
              <span className="bookings-legend__label">{t(`${tKey}legend.order`)}</span>
            </span>
            <span className="bookings-legend__item">
              <span className="bookings-legend__dot bookings-legend__dot--info" />
              <span className="bookings-legend__label">{t(`${tKey}legend.businessOrder`)}</span>
            </span>
          </div>
        </Tabs>
      </div>
    </div>
  );
};

export default RestaurantBookings;
